import { useEffect } from "react";
import { api } from "@/lib/api";
import { applyBrand } from "@/lib/brand";

export function BrandProvider() {
  useEffect(() => {
    api.get("/settings/brand").then((r) => {
      if (r.data?.data) applyBrand(r.data.data);
    }).catch(() => {});
  }, []);
  return null;
}
